import { usePendo } from 'contexts/PendoContext';
import { useCallback } from 'react';

import { ThemeType } from './colorMode';

type ThemeSource = 'top_bar' | 'settings_modal';

export function usePendoTrackTheme() {
    const pendo = usePendo();

    return useCallback(
        (theme: ThemeType, previous_theme: ThemeType, source: ThemeSource) => {
            pendo.track('Theme Selected', { theme, previous_theme, source });
        },
        [pendo],
    );
}
